import { Tooltip } from '@/components/ui/tooltip';
import { cls } from '@/utils/cls';

import {
  type ComplianceStatus,
  isKnownComplianceStatus,
  KnownComplianceStatus,
} from '../entities/compliance-status';

import {
  ComplianceStatusIcon,
  tooltipFromStatus,
} from './compliance-status-icon';

type ComplianceStatusBadgeProps = {
  status: ComplianceStatus;
};

const labelFromStatus: Record<KnownComplianceStatus, string> = {
  [KnownComplianceStatus.NO_DATA]: 'No Data',
  [KnownComplianceStatus.COMPLIANT]: 'Compliant',
  [KnownComplianceStatus.NON_COMPLIANT]: 'Non-Compliant',
  [KnownComplianceStatus.AT_RISK]: 'At Risk',
};

const classNameFromStatus: Record<KnownComplianceStatus, string> = {
  [KnownComplianceStatus.NO_DATA]: 'bg-gray-50 text-gray-700',
  [KnownComplianceStatus.COMPLIANT]: 'bg-green-50 text-green-700',
  [KnownComplianceStatus.NON_COMPLIANT]: 'bg-yellow-50 text-yellow-700',
  [KnownComplianceStatus.AT_RISK]: 'bg-orange-50 text-orange-700',
};

export function ComplianceStatusBadge({ status }: ComplianceStatusBadgeProps) {
  const baseClassName =
    'inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2 py-1 text-xs font-medium';

  if (isKnownComplianceStatus(status)) {
    return (
      <Tooltip delay content={tooltipFromStatus[status]}>
        <span className={cls(baseClassName, classNameFromStatus[status])}>
          <ComplianceStatusIcon status={status} />
          {labelFromStatus[status]}
        </span>
      </Tooltip>
    );
  }

  return (
    <span className={cls(baseClassName, 'bg-gray-50 text-gray-700')}>
      {status}
    </span>
  );
}
